import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"
import _imports_0 from '../../static/icons/arrow_left_icon.svg'
import _imports_1 from '../../static/icons/right-arrow.svg'
import _imports_2 from '../../static/icons/person_icon.svg'
import _imports_3 from '../../static/icons/chevron_right_icon.svg'


const _hoisted_1 = { class: "navigation-phone__options" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "navigation-phone__back-label" }
const _hoisted_4 = { class: "navigation-phone__frame" }
const _hoisted_5 = { class: "navigation-phone__main-layer" }
const _hoisted_6 = { class: "navigation-phone__links-list" }
const _hoisted_7 = { class: "navigation-phone__links-item" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "navigation-phone__links-chevron",
  src: _imports_1
}, null, -1)
const _hoisted_9 = { class: "navigation-phone__user-options" }
const _hoisted_10 = { class: "navigation-phone__user-option-item" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  class: "navigation-phone__user-option-icon",
  src: _imports_2
}, null, -1)
const _hoisted_12 = { class: "navigation-phone__user-option-label" }
const _hoisted_13 = { class: "navigation-phone__tagline" }
const _hoisted_14 = { class: "navigation-phone__category-list" }
const _hoisted_15 = { class: "navigation-phone__category-list-item" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  class: "navigation-phone__links-chevron",
  src: _imports_3
}, null, -1)

import {
  inject,
  ref,
  computed,
  watch,
  onMounted,
} from 'vue';

import DrawerLayer from '@distancify-storefront/ui-drawer-layer';
import { deviceWidths } from "@/constants";

import {
  isNavigationOpenKey,
  categoryTreeKey,
} from '@/keys';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useStoryblokLink from '@/composables/useStoryblokLink';
import PhoneCategoryHighlights from './PhoneCategoryHighlights.vue';
import useContext from '@/composables/useContext';
import useUser from '@/composables/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationPhone',
  setup(__props) {

const { toUrl } = useStoryblokLink();
const { websiteText } = useWebsiteTexts();
const { settings, texts, mitt } = useContext();
const { user } = useUser();

const isNavigationOpen = inject(isNavigationOpenKey, ref(false));

const categoryTree = inject(categoryTreeKey, ref());

const rootCategory = computed(() => categoryTree.value?.[0] || {});
const myPagesText = computed(() => {
  return user.value.isAuthenticated
  ? user.value?.organization?.organizationName
  : texts('login__submit')
});

const categoryLayers = ref<any[]>([]);

const pushCategory = (category: any) => {
  categoryLayers.value.push(category);
};
const popCategory = () => {
  categoryLayers.value.pop();
};

const showPhoneNavigation = computed(() => {
  if (!isMounted.value || typeof window === 'undefined') {
    return false;
  }

  return document.body.clientWidth <= deviceWidths.tabletMaxWidth;
});

const openMyPages = () => {
  mitt.emit('openMyPages');
};

watch(isNavigationOpen, val => {
  if (!val) {
    categoryLayers.value = [];
  }
});

const isMounted = ref(false);

onMounted(() => {
  isMounted.value = true;
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(showPhoneNavigation))
    ? (_openBlock(), _createBlock(_unref(DrawerLayer), {
        key: 0,
        modelValue: _unref(isNavigationOpen),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(isNavigationOpen) ? (isNavigationOpen).value = $event : null)),
        showCloseIcon: true,
        containerClass: "navigation-phone__modal-container"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["navigation-phone", {'navigation-phone--open': _unref(isNavigationOpen)}])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                class: _normalizeClass([{
              'navigation-phone__back--hidden': categoryLayers.value.length == 0
            }, "navigation-phone__back"]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (popCategory()))
              }, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(texts)('global__back')), 1)
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (pushCategory(_unref(rootCategory))), ["prevent"])),
                      class: "navigation-phone__links-link"
                    }, [
                      _createTextVNode(_toDisplayString(_unref(rootCategory).name) + " ", 1),
                      _hoisted_8
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settings)?.mainMenu, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: item._uid,
                      class: "navigation-phone__links-item"
                    }, [
                      _createVNode(_component_router_link, {
                        to: _unref(toUrl)(item.link),
                        class: "navigation-phone__links-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("ul", _hoisted_9, [
                  _createElementVNode("li", _hoisted_10, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (openMyPages()), ["prevent"])),
                      class: "navigation-phone__user-option-link"
                    }, [
                      _hoisted_11,
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(myPagesText)), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(settings)?.tagline), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryLayers.value, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.id,
                  class: "navigation-phone__category-layer"
                }, [
                  _createElementVNode("ul", _hoisted_14, [
                    _createElementVNode("li", _hoisted_15, [
                      _createVNode(_component_router_link, {
                        to: category.url,
                        class: "navigation-phone__category-list-link-root"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(PhoneCategoryHighlights, { category: category }, null, 8, ["category"]),
                          _createTextVNode(" " + _toDisplayString(_unref(texts)(category.id == _unref(rootCategory).id ? 'navigation-phone__show-all' : 'navigation-phone__show-all-from-category', {
                      'category': category.name
                    })), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (child) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: child.id,
                        class: "navigation-phone__category-list-item"
                      }, [
                        (!child.children || child.children?.length === 0)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: child.url,
                              class: _normalizeClass(["navigation-phone__category-list-link", {'navigation-phone__category-list-link--image': child.highlights && child.highlights.length}])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(PhoneCategoryHighlights, { category: child }, null, 8, ["category"]),
                                _createTextVNode(" " + _toDisplayString(child.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to", "class"]))
                          : _createCommentVNode("", true),
                        (child.children?.length > 0)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: "#",
                              onClick: _withModifiers(($event: any) => (pushCategory(child)), ["prevent"]),
                              class: "navigation-phone__category-list-link"
                            }, [
                              _createTextVNode(_toDisplayString(child.name) + " ", 1),
                              _hoisted_17
                            ], 8, _hoisted_16))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})